// TIP-487 (MV Stage 1b) — pure helpers for the "Using TREVEX for" company
// switcher. Both key off the backend `profile_status` ladder (TIP-486):
// verified → member → claimed → listed.

// Status pill label shown next to each company in the switcher.
// `listed` (and anything unknown) shows no pill.
const PILL_LABELS = {
  verified: "Verified Member",
  member: "Member",
  claimed: "Claimed",
};

export const companyStatusPill = (profileStatus) =>
  PILL_LABELS[profileStatus] ?? null;

// Privilege ranking used to choose a sensible default active company.
export const PRIVILEGE_RANK = {
  verified: 3,
  member: 2,
  claimed: 1,
  listed: 0,
};

const rankOf = (item) => PRIVILEGE_RANK[item?.profile_status] ?? 0;

// Pick the most-privileged company from the user's list; ties keep list order.
export const mostPrivilegedCompany = (companies) => {
  if (!Array.isArray(companies) || companies.length === 0) return null;
  return companies.reduce(
    (best, item) => (rankOf(item) > rankOf(best) ? item : best),
    companies[0]
  );
};

// TIP-499 (MV Stage 1c) — resolve which company should be active on first load.
// Honour the user's explicitly chosen default (persisted per-Individual) when
// it is still one of their companies; otherwise fall back to most-privileged.
export const defaultOrMostPrivileged = (companies, defaultCompanyId) => {
  if (!Array.isArray(companies) || companies.length === 0) return null;
  if (defaultCompanyId) {
    const chosen = companies.find((c) => c?.companyID === defaultCompanyId);
    if (chosen) return chosen;
  }
  return mostPrivilegedCompany(companies);
};
